package one.healthium.log_food.ui.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.stack.StackNavigation
import com.arkivanov.decompose.router.stack.childStack
import com.arkivanov.decompose.router.stack.pushNew
import com.arkivanov.decompose.value.Value
import kotlinx.serialization.Serializable
import one.healthium.base.preferences.AppPreferences
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.log_food.ui.navigation.add_food.DefaultAddFoodComponent
import one.healthium.log_food.ui.navigation.find_food.DefaultFindFoodComponent
import one.healthium.profile.ui.food.models.FoodUiModel
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject
import kotlin.time.Clock

class DefaultLogFoodComponent(
    componentContext: ComponentContext,
    override val taskId: String? = null,
    override val food: FoodUiModel? = null,
    private val onCloseClicked: () -> Unit,
    private val onScanBarcode: suspend () -> String?,
) : LogFoodComponent,
    ComponentContext by componentContext,
    ViewModelStoreOwner by componentContext.viewModelStoreOwner(),
    KoinComponent {

    // TODO inject in constructor
    private val appPreferences: AppPreferences by inject()

    private val nav = StackNavigation<Config>()

    private val _stack = childStack(
        source = nav,
        serializer = Config.serializer(),
        initialStack = {
            if (food != null) {
                listOf(Config.AddFood(food))
            } else {
                listOf(Config.FindFood)
            }
        },
        childFactory = ::child,
        handleBackButton = true,
    )

    override val stack: Value<ChildStack<*, LogFoodComponent.Child>> = _stack

    override fun onCloseClicked() = onCloseClicked.invoke()

    private fun child(config: Config, componentContext: ComponentContext): LogFoodComponent.Child {
        return when (config) {
            Config.FindFood -> LogFoodComponent.Child.FindFood(
                DefaultFindFoodComponent(
                    componentContext = componentContext,
                    onFoodClicked = ::onFoodClicked,
                    onScanBarcode = onScanBarcode,
                )
            )

            is Config.AddFood -> LogFoodComponent.Child.AddFood(
                DefaultAddFoodComponent(
                    componentContext = componentContext,
                    food = config.food,
                    onFoodAdded = ::onFoodAdded,
                )
            )
        }
    }

    private fun onFoodClicked(food: FoodUiModel) {
        nav.pushNew(Config.AddFood(food))
    }

    private fun onFoodAdded() {
        if (food != null) {
            appPreferences.latestLogFoodTimestamp = Clock.System.now().toEpochMilliseconds()
        }
        onCloseClicked()
    }

    @Serializable
    private sealed class Config {
        @Serializable
        data object FindFood : Config()

        @Serializable
        data class AddFood(
            val food: FoodUiModel
        ) : Config()
    }
}
